import { Button, Checkbox, Form, Input, Typography } from 'antd'
import Grid from 'antd/lib/card/Grid'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { EMAIL_HT, PASSWORD_HT } from '../../configs/const'
import { RootState } from '../../redux/Reducers'
import { bindActionCreators } from 'redux'
import { loginActionCreator } from '../../redux'
import { LoginDto } from '../../models/LoginDto'
import companyLogoNew from '../../resources/logo_informatics.png'

export interface LoginRequest {
  email: string
  password: string
  rememberMe: boolean
}

export interface LoginFormProps {
  onSubmit(loginRequest: LoginRequest): void
}

export function LoginForm({ onSubmit }: LoginFormProps) {
  // let {t} = useI18n('loginForm.view');

  const navigate = useNavigate()

  const [isPasswordVisible, setPasswordVisible] = useState<boolean>(false)
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [rememberme, setRememberMe] = useState<boolean>(false)
  const [emailHT, setEmailHT] = useState<string>('')
  const [passwordHT, setPasswordHT] = useState<string>('')
  const [loginErr, setLoginErr] = useState<string>('')

  const [form] = Form.useForm()

  const dispatch = useDispatch()
  const loginState: any = useSelector((state: RootState) => state.loginState)
  const { login, CleanLogin } = bindActionCreators(loginActionCreator, dispatch)

  const onFinish = (values: any) => {
    console.log('Success:', values)
    let obj: LoginDto = {
      username: form.getFieldValue('username'),
      password: form.getFieldValue('password'),
    }
    login(obj)
  }

  useEffect(() => {
    console.log(119, loginState)
    if (loginState?.success) {
      console.log(119, loginState)

      navigate('playground')

      CleanLogin()
    } else {
      setLoginErr(loginState?.error)
    }
  }, [loginState])

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  }

  return (
    <>
      <div className="MuiGrid-grid MuiGrid-item loginContainer__column loginContainer__column--left">
        <div className="loginFormContainer">
          <div className="loginFormContainer__logoHolder">
            <img
              className="loginFormContainer__logo"
              src={companyLogoNew}
              alt=""
            />
          </div>
          <div className='loginFormContainer__titleHolder'>
            <div className='iil-txt-header2'>Sign in</div>

            <span style={{ color: "red", fontSize: "12px" }}>{loginErr}</span>
          </div>

          <div className="loginFormContainer__formBody">
            <Form
              name="basic"
              // style={{ maxWidth: 600 }}
              form={form}
              layout="vertical"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <div className="iit__input">
                <Form.Item
                  label="Username"
                  name="username"
                  rules={[{ required: true, message: `${EMAIL_HT}` }]}
                >
                  <Input
                    value={form.getFieldValue('username')}
                    onChange={(e) => {
                      form.setFieldsValue({ username: e.target.value })
                    }}
                  />
                </Form.Item>
              </div>
              <div className="iit__input--password">
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[{ required: true, message: `${PASSWORD_HT}` }]}
                >
                  <Input.Password
                    value={form.getFieldValue('password')}
                    onChange={(e) => {
                      form.setFieldsValue({ password: e.target.value })
                    }}
                  />
                </Form.Item>
              </div>
              <div className="loginFormContainer__navContainer iit__rem">
                   <span
                    className="iil-txt-small"
                    style={{ color: 'red', fontSize: '14px' }}
                  >
                    {loginErr}
                  </span>
               
                {/* <Form.Item name="remember" valuePropName="checked" wrapperCol={{ offset: 2, span: 16 }}>
                  <Checkbox>Remember me</Checkbox>
                </Form.Item>
                 <a style={{ paddingRight: '8px' }} className='iil-txt-small' href='/control-center/forget-password'>
                  Forgot password?
                </a> */}
              </div>
              <div style={{ paddingTop: '40px' }}>
                <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
                  <Button
                    className="iil-roundedbutton iil-btn--primary"
                    type="primary"
                    htmlType="submit"
                    // onClick={() => {
                    //   userLogin()
                    // }}
                  >
                    Login
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </div>
        </div>
      </div>

      {/* <div className="loginContainer__footerHolder">
        <p className="iil-txt-subtletext">© 2010-{new Date().getFullYear()} Informatics International Limited. All Rights Reserved</p>
      </div> */}
    </>
  )
}
